"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SET_LOQATE_API_KEY = exports.LOQATE_TIMEOUT_ERROR_CODE = exports.LOQATE_ADDRESS_SELECT = exports.LOQATE_ADDRESS_SEARCH = void 0;
// ADDRESS SEARCH ACTION CONSTANTS
var LOQATE_ADDRESS_SEARCH = exports.LOQATE_ADDRESS_SEARCH = 'LOQATE_ADDRESS_SEARCH';
var LOQATE_ADDRESS_SELECT = exports.LOQATE_ADDRESS_SELECT = 'LOQATE_ADDRESS_SELECT';
var SET_LOQATE_API_KEY = exports.SET_LOQATE_API_KEY = 'SET_LOQATE_API_KEY';
var LOQATE_TIMEOUT_ERROR_CODE = exports.LOQATE_TIMEOUT_ERROR_CODE = '1005';